import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { Quota, QUOTA_CATEGORY, SurveyMetadataForm } from '@ps/survey-utils';

import { UnicornsApi } from '../../api/unicorns/unicorns.api';

@Injectable({ providedIn: 'root' })
export class UnicornsService {
  private readonly _api = inject(UnicornsApi);

  /** Only nested quotas can match a unicorn record — legacy checks no others. */
  public nestedQuotasIn(quotas: readonly Quota[]): Quota[] {
    return quotas.filter(
      (quota) => quota.quotaCategory === QUOTA_CATEGORY.NESTED,
    );
  }

  /**
   * Ids of the nested quotas flagged improbable. With nothing nested there is
   * nothing a unicorn record could match, so this answers empty without a
   * round-trip rather than posting an empty list.
   */
  public findUnicorns(
    metadata: SurveyMetadataForm,
    nestedQuotas: readonly Quota[],
  ): Observable<string[]> {
    if (!nestedQuotas.length) {
      return of([]);
    }

    return this._api.findUnicorns({ metadata, quotas: nestedQuotas });
  }
}
